import { render } from "./rbd.vue?vue&type=template&id=42a56d92"
import script from "./rbd.vue?vue&type=script&lang=js"
export * from "./rbd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__